module.exports = __webpack_public_path__ + "static/media/close-icon.824b56aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/close-icon.svg
// module id = 1954
// module chunks = 1